import { CreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/CreateTermineFormContext';
import { useCreateTermineForm } from '@/domain/termine/features/CreateTermin/shared/hooks/useCreateTermineForm';
import { ReactNode, useMemo } from 'react';
import { useIsMobile } from '@/components/form/hooks/useIsMobile';

interface CreateTermineFormProviderProps {
  children: ReactNode;
}

export function CreateTermineFormProvider({
  children,
}: CreateTermineFormProviderProps) {
  const formTanstackForm = useCreateTermineForm();
  const isMobile = useIsMobile();
  const contextValue = useMemo(
    () => ({ form: formTanstackForm, isMobile, isDesktop: !isMobile }),
    [formTanstackForm, isMobile],
  );

  return (
    <CreateTermineFormContext.Provider value={contextValue}>
      <form
        className="h-full"
        onSubmit={(e) => {
          e.preventDefault();
          contextValue.form.handleSubmit();
        }}>
        {children}
      </form>
    </CreateTermineFormContext.Provider>
  );
}
